// extracted by mini-css-extract-plugin
export default {"wrapper":"Timer_wrapper__+Xwrh","wrapper__content":"Timer_wrapper__content__Z2dyM","pre_sale":"Timer_pre_sale__PNTMy","title":"Timer_title__qpyZ6"};